import {
  type Icon,
  Books as BooksIcon,
  ForkKnife as ForkKnifeIcon,
  Storefront as StorefrontIcon,
  ShoppingCartSimple as ShoppingCartSimpleIcon,
  Brandy as BrandyIcon,
  Coffee as CoffeeIcon,
  Baby as BabyIcon,
  Bus as BusIcon,
  Train as TrainIcon,
  TrafficSignal as TrafficSignalIcon,
  Tree as TreeIcon,
  Barbell as BarbellIcon,
  Heartbeat as HeartbeatIcon,
  PawPrint as PawPrintIcon,
  GasPump as GasPumpIcon,
  Palette as PaletteIcon,
  Armchair as ArmchairIcon,
  Brain as BrainIcon,
} from "@phosphor-icons/react";
import type { POICategory, POIGroup, SchoolGroup } from "./types";

export const categories: {
  [key in POICategory]: {
    icon: Icon;
    pois: POIGroup | SchoolGroup;
  };
} = {
  schools: {
    icon: BooksIcon,
    pois: ["primary_schools", "high_schools"],
  },
  restaurants: {
    icon: ForkKnifeIcon,
    pois: ["restaurants", "healthy_restaurants"],
  },
  groceries: {
    icon: StorefrontIcon,
    pois: ["groceries", "groceries_specialized"],
  },
  shopping: {
    icon: ShoppingCartSimpleIcon,
    pois: ["shopping"],
  },
  nightlife: {
    icon: BrandyIcon,
    pois: ["nightlife"],
  },
  cafes: {
    icon: CoffeeIcon,
    pois: ["cafes"],
  },
  daycares: {
    icon: BabyIcon,
    pois: ["daycares"],
  },
  busStops: {
    icon: BusIcon,
    pois: ["bus_stops"],
  },
  metroStations: {
    icon: TrainIcon,
    pois: ["rapid_transit_stations"],
  },
  trainStations: {
    icon: TrafficSignalIcon,
    pois: ["train_stations"],
  },
  parks: {
    icon: TreeIcon,
    pois: ["parks"],
  },
  fitness: {
    icon: BarbellIcon,
    pois: ["fitness", "sport_facilities"],
  },
  medical: {
    icon: HeartbeatIcon,
    pois: ["health_care"],
  },
  petCare: {
    icon: PawPrintIcon,
    pois: ["pet_care"],
  },
  fuelStations: {
    icon: GasPumpIcon,
    pois: ["car_fueling_stations"],
  },
  activities: {
    icon: PaletteIcon,
    pois: ["art_culture_science"],
  },
  homeImprovement: {
    icon: ArmchairIcon,
    pois: ["home_improvement"],
  },
  personalCare: {
    icon: BrainIcon,
    pois: ["personal_care"],
  },
};

// km and mi
export const radiusOptions = {
  metric: [3, 6, 9],
  imperial: [2, 4, 6],
};
